import React, { useContext, useEffect, useState } from 'react';
import BreadCrumb from '../../Common/BreadCrumb';
import { Button, Card, CardBody, CardHeader, Col, Modal, ModalBody, ModalHeader, Row, Spinner, Table } from 'reactstrap';
import DateFilter from '../../Common/DateFilter';
import { toast } from 'react-toastify';
import { GlobalStore } from '../../../StateStores';
import moment from 'moment';
import { getVehicleRouteInspectionReports, getVehicleRouteList } from '../../../Actions/InspectionActs';
import InspectionReport from '../InspectionReport';

const VehicleRoutes = ()=>{
    const [modal, setModal] = useState(false);
    const [routes, setRoutes] = useState([]);
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment());
    const [selectedRoute, setSelectedRoute] = useState({});
    const [inspectionCheckpointReport, setInspectionCheckpointReport] = useState([]);

    const {InspectionDispatch,InspectionState:{
        getVehicleRoutes:{loading},
        getVehicleRouteInspections:{loading:inspectionLoading},
    }} = useContext(GlobalStore);

    const loadVehicleRoutes = async ()=>{
        try {
            const response = await getVehicleRouteList({
                fromdate: startDate?.format('YYYY-MM-DD'),
                todate: endDate?.format('YYYY-MM-DD')
            })(InspectionDispatch)
            if(response.status){
                setRoutes(response.data)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error.message)
        }
    }

    useEffect(()=>{
        loadVehicleRoutes();
    },[startDate, endDate])

    const togOpenModal = ()=>{
        setModal(!modal);
    }

    const previewVehicleInspectionReports = async (route)=>{
        togOpenModal();
        setSelectedRoute(route)

        try {
            const response = await getVehicleRouteInspectionReports(route)(InspectionDispatch);
            if(response.status){
                setInspectionCheckpointReport(response.data)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message)
        }

    }

    return(
        <React.Fragment>
            <Modal fullscreen size='md' isOpen={modal}  toggle={() => { togOpenModal() }}>
                <ModalHeader className='mb-2' toggle={() => { togOpenModal() }}>Vehicle inspection reports</ModalHeader>
                <ModalBody className="bg-light">
                    {inspectionLoading && (
                        <div className='d-flex justify-content-center p-4'>
                            <Spinner/>
                        </div>
                    )}
                    
                    {!inspectionLoading && <InspectionReport data={inspectionCheckpointReport}/>}
                </ModalBody>
            </Modal>
            
            <div className='mt-5'>
                <BreadCrumb title="Routes" pageTitle="Vehicle"/>
                <Card className='shadow-sm'>
                    <CardHeader tag="div">
                        <Row>
                            <Col>
                                <DateFilter 
                                    startDate={startDate}
                                    endDate={endDate}
                                    onDatesChange={({ startDate, endDate }) => {
                                        setStartDate(startDate);
                                        setEndDate(endDate);
                                    }}
                                />
                            </Col>
                            <Col>
                                {/* <Button><span className='ri-search-line'></span> Filter</Button>  */}
                                <Button onClick={loadVehicleRoutes} className='ms-1'><span className='ri-refresh-line'></span> Refresh</Button></Col>
                            <Col></Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Table bordered size="sm" className='caption-top'>
                            <caption>
                                {loading && <Spinner size="sm"/>}
                            </caption>
                            <thead className="bg-light">
                                <tr>
                                    <th>#</th>
                                    <th>Route#</th>
                                    <th>Owner</th>
                                    <th>Reg number</th>
                                    <th>Vehicle</th>
                                    <th className='text-center'>Start point</th>
                                    <th className='text-center'>Destination</th>
                                    <th className='text-center'>Creation Date</th>
                                    <th className='text-center'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(routes || []).map((item,index)=>(
                                    <tr>
                                        <td>{++index}</td>
                                        <td>{item?.id}</td>
                                        <td>{item?.owner_name}</td>
                                        <td>{item?.registration_number}</td>
                                        <td>
                                            <p className='mb-0'>{item?.vehicle}</p>
                                            <small className='text-muted'>{item?.chassis_number}</small>
                                        </td>
                                        <td>{item?.route_from}</td>
                                        <td>{item?.route_to}</td>
                                        <td className='text-center'>{moment(item?.created_at).format('YYYY-MM-DD')}</td>
                                        <td>
                                            <div className='d-flex justify-content-center'>
                                                <Button size='sm' onClick={(e)=>{
                                                    previewVehicleInspectionReports(item)
                                                }}>
                                                    <span className='ri-folder-settings-line'></span>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </div>
        </React.Fragment>
    )
}

export default VehicleRoutes;